// Central version marker — bumped on each user-visible release.
export const APP_VERSION = "1.31.73";
export const APP_BUILD = "2026-06-04n";
export const APP_CODENAME = "ledger-commission-single-debit";

export const BUILD_LABEL = `MICM v${APP_VERSION} · build ${APP_BUILD}`;
